<template>
  <!-- 产品功能区域 -->
  <section class="payment-icons-section d-flex align-items-center">
    <div class="container payment-icons-container">
      <div class="row justify-content-center m-5 title">
        產品特點
      </div>
      <div class="row m-1" v-if="list.length > 4">
        <div class="col-md-4 pb-5" v-for="item in list">
          <div class="desc d-flex flex-column justify-content-center align-items-center">
            <div class="img-border d-flex justify-content-center align-items-center"><img :src="getImage(item.imgSrc)" class="payment-icon"></div>
            <div>{{ item.desc }}</div>
          </div>
        </div>
      </div>
      <div class="row m-1" v-else>
        <div class="col-md-3 pb-5" v-for="item in list">
          <div class="desc d-flex flex-column justify-content-center align-items-center">
            <div class="img-border d-flex justify-content-center align-items-center"><img :src="getImage(item.imgSrc)" class="payment-icon"></div>
            <div>{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'ProductFeature',
  props: {
    list: {
      type: Array,
      required: true,
      validator: value => value.length > 0
    },
  },
  data() {
    return {
    }
  },
  computed: {
    
  },
  methods: {
    getImage(name) {
      return require(`@/assets/uupay/icon/svg/${name}.svg`)
    }
  }
}
</script>
<style scoped>
.payment-icons-section {
  background-color: #fff;
  color: #21042e;
  position: relative;
  z-index: 1;
}

@media (min-width: 1700px) {
  .modules-section-container {
    max-width: 1440px;
  }
}
.img-border {
  background: #f8f8f8;
  width: 100px;
  height: 100px;
  border-radius: 60px;
  border: 1px solid #f5f5f5;
  margin-bottom: 1rem;
}
.payment-icons-container .desc {
  margin-top: 1rem;
  font-size: 26px;
}
.payment-icons-container .title {
  font-size: 42px;
  line-height: 60px;
  font-weight: 600;
}

.payment-icons-container .payment-icon {
  width: auto;
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/ProductFeature.vue